const models = new Map();

const getModel = (Model) => {
  if (!models.has(Model)) models.set(Model, new Model());

  return models.get(Model);
};

export default getModel;
